export default {"src":"/_next/static/media/0x5e8422345238f34275888049021821e8e08caa1f.3519056b.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};